import { createApi } from '@reduxjs/toolkit/query/react';
import rtkFetchRequest from '../configs/rtkFetchRequest';

export const deviceApi = createApi({
  reducerPath: 'devices',
  baseQuery: rtkFetchRequest(),
  endpoints: (builder) => ({
    getListDevicesBySn: builder.query({
      query: () => ({
        method: 'GET',
        endpoint: `/subscriptions/get_devices_data`,
      }),
    }),
    deviceSignalScan: builder.mutation({
      query: ({ ...params }) => ({
        method: 'POST',
        endpoint: `/devices/signal_scan`,
        body: params,
      }),
    }),
    deviceRestartConnection: builder.mutation({
      query: ({ ...params }) => ({
        method: 'POST',
        endpoint: `/devices/restart_connection`,
        body: params,
      }),
    }),
    // getDevicePlansByShopifyProdId: builder.query({
    //   query: (shopifyProductId) => ({
    //     endpoint: `/devices/get_device_plans_by_shopify_id?product_id=${shopifyProductId}`,
    //     useAuth: true,
    //   }),
    // }),
  }),
});

export const {
  useGetListDevicesBySnQuery,
  useLazyGetListDevicesBySnQuery,
  useDeviceSignalScanMutation,
  useDeviceRestartConnectionMutation,
  // useGetDevicePlansByShopifyProdIdQuery,
} = deviceApi;
